import React, { useEffect, useState, Children, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from '../components/CTAButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { FAQSection } from '../components/FAQSection';
import { WistiaVideo } from '../components/WistiaVideo';
import { Check, CheckCircle, Clock, Calendar, MapPin, AlertTriangle, X, Target, Battery, Zap, Gift } from 'lucide-react';
export function SalesPage() {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [notifications, setNotifications] = useState<Array<{
    id: number;
    name: string;
    location: string;
    time: string;
  }>>([]);
  // Wistia Scripts
  useEffect(() => {
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.body.appendChild(playerScript);
    const videoIds = ['zadn492ltd', 'n6ngvv6hee', 'psa74yg6wr', '4d7zhpdcnk', '9yq00dgg3u'];
    const scriptElements: HTMLScriptElement[] = [];
    videoIds.forEach(id => {
      const script = document.createElement('script');
      script.src = `https://fast.wistia.com/embed/${id}.js`;
      script.async = true;
      script.type = 'module';
      document.body.appendChild(script);
      scriptElements.push(script);
    });
    return () => {
      document.body.removeChild(playerScript);
      scriptElements.forEach(script => document.body.removeChild(script));
    };
  }, []);
  // Registration Notifications
  useEffect(() => {
    const names = ['María González', 'Carlos Rodríguez', 'Ana Martínez', 'Luis Fernández', 'Carmen López', 'Jorge Sánchez', 'Patricia Ramírez', 'Roberto Torres'];
    const cities = [{
      city: 'Houston',
      country: 'USA'
    }, {
      city: 'Caracas',
      country: 'Venezuela'
    }, {
      city: 'Bogotá',
      country: 'Colombia'
    }, {
      city: 'Guadalajara',
      country: 'México'
    }, {
      city: 'Valencia',
      country: 'Venezuela'
    }, {
      city: 'Cali',
      country: 'Colombia'
    }];
    const showNotification = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomLocation = cities[Math.floor(Math.random() * cities.length)];
      const minutesAgo = Math.floor(Math.random() * 30) + 1;
      const timeText = minutesAgo === 1 ? 'hace 1 minuto' : `hace ${minutesAgo} minutos`;
      const newNotification = {
        id: Date.now(),
        name: randomName,
        location: `${randomLocation.city}, ${randomLocation.country}`,
        time: timeText
      };
      setNotifications(prev => [...prev, newNotification]);
      setTimeout(() => {
        setNotifications(prev => prev.filter(n => n.id !== newNotification.id));
      }, 5000);
    };
    const firstTimeout = setTimeout(showNotification, 3000);
    const interval = setInterval(() => {
      showNotification();
    }, Math.random() * 10000 + 15000);
    return () => {
      clearTimeout(firstTimeout);
      clearInterval(interval);
    };
  }, []);
  const fadeInUp = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const staggerContainer = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  return <div className="min-h-screen bg-white text-slate-800 font-sans selection:bg-orange-500/30" data-id="element-33">
      {/* HEADER */}
      <header className="w-full bg-white border-b border-slate-100 px-4 md:px-6 py-2.5" data-id="element-34">
        <div className="max-w-6xl mx-auto flex items-center justify-between gap-4" data-id="element-35">
          <div className="flex items-center gap-3" data-id="element-36">
            <img src="https://cdn.magicpatterns.com/uploads/hUfDsauVfEYX7kKr7gvPvr/Logo_JDON.png" alt="JDON Logo" className="h-9 w-auto" data-id="element-37" />
            <span className="hidden sm:inline text-sm font-bold text-slate-800 tracking-tight" data-id="element-38">
              JUEGA DESDE OTRO NIVEL
            </span>
          </div>
          <div className="flex items-center gap-2 text-xs md:text-sm text-slate-500 font-medium" data-id="element-39">
            <Calendar className="w-4 h-4 text-orange-500 flex-shrink-0" data-id="element-40" />
            <span data-id="element-41">Sáb 28 Feb · 10:00 am VEN · Zoom en vivo</span>
          </div>
        </div>
      </header>

      <style data-id="element-42">{`
        wistia-player[media-id='zadn492ltd']:not(:defined) {
          background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/zadn492ltd/swatch');
          display: block;
          filter: blur(5px);
          padding-top: 193.61%;
        }
        wistia-player[media-id='n6ngvv6hee']:not(:defined) {
          background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/n6ngvv6hee/swatch');
          display: block;
          filter: blur(5px);
          padding-top: 177.78%;
        }
        wistia-player[media-id='psa74yg6wr']:not(:defined) {
          background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/psa74yg6wr/swatch');
          display: block;
          filter: blur(5px);
          padding-top: 177.78%;
        }
        wistia-player[media-id='4d7zhpdcnk']:not(:defined) {
          background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/4d7zhpdcnk/swatch');
          display: block;
          filter: blur(5px);
          padding-top: 173.33%;
        }
        wistia-player[media-id='9yq00dgg3u']:not(:defined) {
          background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/9yq00dgg3u/swatch');
          display: block;
          filter: blur(5px);
          padding-top: 177.78%;
        }
      `}</style>

      {/* Registration Notifications */}
      <div className="fixed bottom-6 left-6 z-50 space-y-3 pointer-events-none" data-id="element-43">
        <AnimatePresence data-id="element-44">
          {notifications.map(notification => <motion.div key={notification.id} initial={{
          opacity: 0,
          x: -100,
          scale: 0.9
        }} animate={{
          opacity: 1,
          x: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          x: -100,
          scale: 0.9
        }} transition={{
          type: 'spring',
          stiffness: 200,
          damping: 20
        }} className="bg-white rounded-xl shadow-2xl border border-green-100 p-4 max-w-sm backdrop-blur-sm pointer-events-auto" data-id="element-45">
              <div className="flex items-start gap-3" data-id="element-46">
                <div className="flex-shrink-0 mt-0.5" data-id="element-47">
                  <CheckCircle className="w-5 h-5 text-green-500" data-id="element-48" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-49">
                  <p className="font-semibold text-slate-900 text-sm truncate" data-id="element-50">
                    {notification.name}
                  </p>
                  <p className="text-slate-500 text-xs mt-0.5" data-id="element-51">
                    {notification.location}
                  </p>
                  <p className="text-slate-600 text-xs mt-1.5" data-id="element-52">
                    Se registró al entrenamiento
                  </p>
                  <p className="text-slate-400 text-xs mt-1" data-id="element-53">
                    {notification.time}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </AnimatePresence>
      </div>

      {/* 1. HERO SECTION */}
      <section className="relative px-6 pt-24 pb-20 md:pt-32 md:pb-28 overflow-hidden" data-id="element-54">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-orange-100/30 rounded-full blur-3xl -z-10" data-id="element-55" />

        <div className="max-w-4xl mx-auto text-center" data-id="element-56">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} data-id="element-57">
            <h1 className="font-extrabold tracking-tight mb-6 leading-tight" data-id="element-58">
              <span style={{
              color: '#FA7315',
              fontSize: '28px'
            }} data-id="element-59">
                No estás vendiendo por debajo de tu nivel.
              </span>
              <br data-id="element-60" />
              <span className="text-slate-600 block mt-2" style={{
              fontSize: '20px'
            }} data-id="element-61">
                Estás operando por debajo de tu nivel.
              </span>
            </h1>

            <div className="mb-8" data-id="element-62">
              <img src="https://cdn.magicpatterns.com/uploads/tWKXkCujAs6uvHRUg9cu4W/imagen_de_arriba_de_la_pagina.jpg" alt="Carolina - Vender no es un trabajo. Es un negocio." className="w-full rounded-2xl shadow-xl" data-id="element-63" />
            </div>

            <p className="text-xl md:text-2xl text-slate-800 font-medium max-w-3xl mx-auto mb-6" data-id="element-64">
              En 90 minutos identificas y eliminas las fugas que hoy te cuestan
              tiempo, foco y cierres.
            </p>

            <p className="text-slate-500 text-base md:text-lg mb-10 italic" data-id="element-65">
              Sin motivación. Sin teoría innecesaria. Con criterio, decisiones y
              sistema.
            </p>

            <div className="bg-white/50 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-slate-200 shadow-sm inline-block text-left mb-10" data-id="element-66">
              <ul className="space-y-4" data-id="element-67">
                {['Detectas las horas que NO retornan y las cortas.', 'Te quedas con tu 20% que sí genera cierres.', 'Sales con un Sistema Mínimo semanal para sostener resultados.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-68">
                    <Check className="w-6 h-6 text-orange-500 flex-shrink-0" data-id="element-69" />
                    <span className="text-slate-800 font-semibold text-lg" data-id="element-70">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col items-center gap-4" data-id="element-71">
              <CTAButton text="AJUSTAR MI NIVEL AHORA" subtitle="Acceso inmediato · $15 USD · Zoom en vivo" scrollTo="pricing" className="w-full md:w-auto md:px-12" data-id="element-72" />
              <p className="text-sm font-semibold text-slate-500" data-id="element-73">
                +21 años en ventas reales. Esto no es "inspiración". Es
                criterio.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* 2. PROBLEM SECTION */}
      <section className="px-6 py-20 bg-slate-50" data-id="element-74">
        <div className="max-w-3xl mx-auto" data-id="element-75">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} data-id="element-76">
            <h2 className="font-bold text-slate-900 mb-8" style={{
            fontSize: '28px'
          }} data-id="element-77">
              Si hoy:
            </h2>
            <ul className="space-y-5 mb-12" data-id="element-78">
              {['Tu agenda está llena, pero tu impacto no crece.', 'Tomas decisiones cansado y eso cuesta cierres.', 'Se enfrían seguimientos porque apagaste incendios.', 'Respondes mucho… y cierras menos de lo que podrías.', 'Ves a otros avanzar "más rápido" porque tienen sistema, no porque sean mejores.'].map((item, index) => <li key={index} className="flex items-start gap-4 text-slate-700 text-lg" data-id="element-79">
                  <X className="flex-shrink-0 mt-1 text-red-500 w-6 h-6" data-id="element-80" />
                  <span dangerouslySetInnerHTML={{
                __html: item.replace('no porque sean mejores', '<strong>no porque sean mejores</strong>')
              }} data-id="element-81" />
                </li>)}
            </ul>

            <div className="bg-white p-8 rounded-2xl border-l-4 border-orange-500 shadow-sm space-y-4" data-id="element-82">
              <p className="text-xl font-bold text-slate-900" data-id="element-83">
                No tienes un problema de ventas. Tienes un problema de
                estructura.
              </p>
              <p className="text-lg text-slate-700" data-id="element-84">
                Si todo depende de ti, el sistema está mal diseñado.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* 3. INVESTMENT CONCEPT */}
      <section className="px-6 py-24 bg-white text-center" data-id="element-85">
        <div className="max-w-4xl mx-auto" data-id="element-86">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} className="space-y-8" data-id="element-87">
            <h2 className="font-bold text-slate-900 leading-tight" style={{
            fontSize: '28px'
          }} data-id="element-88">
              El problema no es que hagas poco. <br data-id="element-89" />
              <span className="text-orange-600" data-id="element-90">
                El problema es que estás haciendo trabajo que no debería
                existir.
              </span>
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12 text-left" data-id="element-91">
              <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100" data-id="element-92">
                <h3 className="text-xl font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-93">
                  <Clock className="text-slate-400" data-id="element-94" /> Tu tiempo no se "gasta".
                </h3>
                <p className="text-2xl font-bold text-slate-900" data-id="element-95">
                  Se invierte.
                </p>
              </div>
              <div className="bg-orange-50 p-8 rounded-2xl border border-orange-100" data-id="element-96">
                <h3 className="text-xl font-bold text-orange-900 mb-4 flex items-center gap-2" data-id="element-97">
                  <AlertTriangle className="text-orange-500" data-id="element-98" /> Y si no
                  retorna...
                </h3>
                <p className="text-2xl font-bold text-orange-900" data-id="element-99">
                  ...es fuga.
                </p>
                <p className="mt-2 text-orange-800/80" data-id="element-100">
                  (En cierres, pipeline o equipo)
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* 4. WHAT IS IT */}
      <section className="px-6 py-20 bg-slate-900 text-white" data-id="element-101">
        <div className="max-w-4xl mx-auto text-center" data-id="element-102">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} data-id="element-103">
            <span className="inline-block px-4 py-1 rounded-full bg-orange-500/20 text-orange-400 font-bold text-sm tracking-wider mb-6" data-id="element-104">
              QUÉ ES "JUEGA DESDE OTRO NIVEL"
            </span>
            <p className="text-2xl md:text-3xl font-medium leading-relaxed" data-id="element-105">
              Juega Desde Otro Nivel es una intervención estratégica de 90
              minutos para vendedores y líderes que ya tienen resultados… pero
              saben que el negocio todavía depende demasiado de su empuje.
            </p>
            <p className="mt-8 text-xl text-slate-400" data-id="element-106">
              Aquí no vienes a sentirte bien. Vienes a ordenar el juego.
            </p>
          </motion.div>
        </div>
      </section>

      {/* 5. MODULES */}
      <section className="px-6 py-24 bg-white" data-id="element-107">
        <div className="max-w-5xl mx-auto" data-id="element-108">
          <div className="text-center mb-16" data-id="element-109">
            <h2 className="font-bold text-slate-900" style={{
            fontSize: '28px'
          }} data-id="element-110">
              LO QUE TRABAJAMOS EN LA SESIÓN
            </h2>
            <p className="text-slate-600 mt-4 text-lg" data-id="element-111">
              En 90 minutos vas a trabajar:
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-112">
            {[{
            icon: <Target className="w-8 h-8 text-orange-500" data-id="element-113" />,
            title: 'Tu hora vale (o te cuesta)',
            desc: 'Si no sabes cuánto vale tu hora, estás perdiendo dinero sin verlo.'
          }, {
            icon: <Zap className="w-8 h-8 text-orange-500" data-id="element-114" />,
            title: '80/20 aplicado de verdad',
            desc: 'No para "enfocarte", sino para eliminar el 80% que te drena.'
          }, {
            icon: <Battery className="w-8 h-8 text-orange-500" data-id="element-115" />,
            title: 'Las 3 fugas invisibles',
            desc: 'Tiempo, Energía/Entorno y Foco. Aquí está el techo invisible.'
          }, {
            icon: <CheckCircle className="w-8 h-8 text-orange-500" data-id="element-116" />,
            title: 'Sistemas > Metas',
            desc: 'Cómo dejar de depender de voluntad y crear una estructura mínima que sostenga avance.'
          }].map((item, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="p-8 rounded-2xl border border-slate-200 hover:border-orange-200 hover:shadow-lg transition-all bg-white" data-id="element-117">
                <div className="mb-4 bg-orange-50 w-16 h-16 rounded-full flex items-center justify-center" data-id="element-118">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-119">
                  {item.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-120">{item.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* 6. MOCKUPS */}
      <section className="px-6 py-12 bg-slate-50" data-id="element-121">
        <div className="max-w-5xl mx-auto" data-id="element-122">
          <img src="https://cdn.magicpatterns.com/uploads/qFWbbBj2UDmjZarwQ2pvq9/MockUp_libro.jpg" alt="Mockup del Programa de Entrenamiento Juega Desde Otro Nivel - cuaderno, laptop y celular" className="w-full rounded-2xl shadow-xl" data-id="element-123" />
        </div>
      </section>

      {/* 7. WRITTEN TESTIMONIALS */}
      <section className="px-6 py-24 bg-white" data-id="element-124">
        <div className="max-w-7xl mx-auto" data-id="element-125">
          <div className="text-center mb-16" data-id="element-126">
            <h2 className="font-bold text-slate-900 mb-4" style={{
            fontSize: '28px'
          }} data-id="element-127">
              Resultados de personas que no buscaban motivación.
            </h2>
            <p className="text-xl text-orange-600 font-bold" data-id="element-128">
              Buscaban estructura.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-129">
            <TestimonialCard quote="Entendí que no estaba cansada… estaba mal organizada. En una sesión tomé decisiones que postergué meses." linkText="Ver historia" linkUrl="#" imageUrl="https://cdn.magicpatterns.com/uploads/g2bfbmTWTUZShfswFwM4fV/Tettimonio_Roger.jpg" delay={0} data-id="element-130" />
            <TestimonialCard quote="Dejé de regalar horas. Ajusté mi agenda y mejoraron mis cierres en la misma semana." linkText="Ver historia" linkUrl="#" imageUrl="https://cdn.magicpatterns.com/uploads/3HEAYqYadj34Rqm7difeG2/Rosaurita_Perdomo.jpg" delay={0.1} data-id="element-131" />
            <TestimonialCard quote="No necesitaba otro curso. Necesitaba criterio. Y aquí lo encontré." linkText="Ver historia" linkUrl="#" imageUrl="https://cdn.magicpatterns.com/uploads/pWP23F7JNsyeDTGyK86cf4/Diana_moreno.jpg" delay={0.2} data-id="element-132" />
            <TestimonialCard quote="Lo que más valoro es que sales con un plan real, no con ideas bonitas." linkText="Ver historia" linkUrl="#" imageUrl="https://cdn.magicpatterns.com/uploads/mYXcFxWBJHgK5ScwyhLMJF/Testimonio_Wh_Maria_Consuelo_Restrepo_Entrenamiento.jpg" delay={0.3} data-id="element-133" />
          </div>
        </div>
      </section>

      {/* 8. VIDEO TESTIMONIALS */}
      <section className="px-6 py-20 bg-slate-50" data-id="element-134">
        <div className="max-w-7xl mx-auto" data-id="element-135">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-136">
            {[{
            id: 'zadn492ltd',
            aspect: '0.5164992826398852'
          }, {
            id: 'n6ngvv6hee',
            aspect: '0.5625'
          }, {
            id: 'psa74yg6wr',
            aspect: '0.5625'
          }, {
            id: '4d7zhpdcnk',
            aspect: '0.5769230769230769'
          }].map((video, idx) => <motion.div key={video.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-137">
                <WistiaVideo mediaId={video.id} aspect={video.aspect} data-id="element-138" />
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* 8b. VIDEO TESTIMONIO ASISTENTE */}
      <section className="px-6 py-12 bg-slate-50" data-id="element-139">
        <div className="max-w-4xl mx-auto" data-id="element-140">
          <WistiaVideo mediaId="9yq00dgg3u" className="rounded-2xl overflow-hidden shadow-xl" data-id="element-141" />
        </div>
      </section>

      {/* 9. PRICING / CLOSING */}
      <section id="pricing" className="px-6 py-24 bg-white" data-id="element-142">
        <div className="max-w-4xl mx-auto" data-id="element-143">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-slate-900 text-white rounded-3xl overflow-hidden shadow-2xl" data-id="element-144">
            <div className="p-8 md:p-12 text-center border-b border-slate-800" data-id="element-145">
              <h2 className="font-bold mb-8" style={{
              fontSize: '28px'
            }} data-id="element-146">
                Lo que te llevas en 90 minutos:
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left max-w-2xl mx-auto mb-8" data-id="element-147">
                {['Diagnóstico claro de tus fugas', 'Decisión del 20% que sí retorna', 'Sistema mínimo semanal', 'Plan de acción de 7 días', 'Sesión de preguntas y respuestas en vivo'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-148">
                    <Check className="text-green-400 w-5 h-5 flex-shrink-0" data-id="element-149" />
                    <span className="text-slate-200" data-id="element-150">{item}</span>
                  </div>)}
              </div>
            </div>

            <div className="p-8 md:p-12 bg-slate-800/50 text-center" data-id="element-151">
              <p className="text-slate-400 uppercase tracking-widest text-sm font-bold mb-2" data-id="element-152">
                INVERSIÓN
              </p>
              <div className="text-5xl md:text-6xl font-black text-white mb-8" data-id="element-153">
                $15 USD
              </div>

              <div className="flex flex-wrap justify-center gap-6 mb-10 text-slate-300 font-medium" data-id="element-154">
                <div className="flex items-center gap-2" data-id="element-155">
                  <MapPin className="w-5 h-5 text-orange-500" data-id="element-156" />
                  Zoom en vivo
                </div>
                <div className="flex items-center gap-2" data-id="element-157">
                  <Clock className="w-5 h-5 text-orange-500" data-id="element-158" />
                  90 minutos prácticos
                </div>
              </div>

              <CTAButton text="QUIERO AJUSTAR MI NIVEL AHORA" href="https://coneckta.co/taller-juegadesdeotronivel" fullWidth={true} className="w-full md:max-w-md text-lg" data-id="element-159" />

              <p className="mt-6 text-sm text-slate-400" data-id="element-160">
                No más desgaste. No más improvisación. Decisiones claras.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* 10. LIVE BONUS */}
      <section className="px-6 py-20 bg-orange-50 border-y border-orange-100" data-id="element-161">
        <div className="max-w-4xl mx-auto text-center" data-id="element-162">
          <span className="inline-block px-4 py-1.5 bg-orange-100 text-orange-700 rounded-full text-sm font-bold mb-8 tracking-wide" data-id="element-163">
            🎁 Bonos exclusivos para asistentes en vivo
          </span>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left max-w-3xl mx-auto" data-id="element-164">
            <div className="bg-white rounded-2xl p-7 border border-orange-200 shadow-sm" data-id="element-165">
              <div className="flex items-center gap-3 mb-3" data-id="element-166">
                <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0" data-id="element-167">
                  <Gift className="w-5 h-5 text-orange-600" data-id="element-168" />
                </div>
                <p className="text-orange-600 font-bold text-sm" data-id="element-169">BONO 1</p>
              </div>
              <h3 className="text-lg font-bold text-slate-900" data-id="element-170">
                Arquitectura de delegación inteligente
              </h3>
              <p className="text-slate-600 text-sm mt-2 leading-relaxed" data-id="element-171">
                Cómo liberar horas críticas sin perder control ni rentabilidad.
              </p>
            </div>
            <div className="bg-white rounded-2xl p-7 border border-orange-200 shadow-sm" data-id="element-172">
              <div className="flex items-center gap-3 mb-3" data-id="element-173">
                <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0" data-id="element-174">
                  <Gift className="w-5 h-5 text-orange-600" data-id="element-175" />
                </div>
                <p className="text-orange-600 font-bold text-sm" data-id="element-176">BONO 2</p>
              </div>
              <h3 className="text-lg font-bold text-slate-900" data-id="element-177">
                Mapa estratégico 80/20 de retorno
              </h3>
              <p className="text-slate-600 text-sm mt-2 leading-relaxed" data-id="element-178">
                La herramienta para identificar tu 20% crítico y eliminar el 80%
                que drena tu negocio.
              </p>
            </div>
          </div>
          <p className="text-slate-500 text-sm mt-8" data-id="element-179">
            (No disponible en la grabación)
          </p>
        </div>
      </section>

      {/* 11. WHO IS IT FOR */}
      <section className="px-6 py-24 bg-white" data-id="element-180">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-181">
          <div className="bg-green-50/50 rounded-2xl border border-green-100 p-8 space-y-6" data-id="element-182">
            <h3 className="text-2xl font-bold text-slate-900 flex items-center gap-3" data-id="element-183">
              <CheckCircle className="text-green-500 w-7 h-7" data-id="element-184" /> Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-185">
              {['Vendes, pero tu agenda no retorna como debería.', 'Tu negocio depende de tu empuje para avanzar.', 'Quieres cerrar más con criterio y estructura, no con más horas.', 'Te cansaste de estar ocupado sin subir nivel.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-700 text-base" data-id="element-186">
                  <Check className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-187" />
                  <span data-id="element-188">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-red-50/50 rounded-2xl border border-red-100 p-8 space-y-6" data-id="element-189">
            <h3 className="text-2xl font-bold text-slate-900 flex items-center gap-3" data-id="element-190">
              <X className="text-red-500 w-7 h-7" data-id="element-191" /> No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-192">
              {['Buscas motivación', 'Crees que vender es hacer más', 'No estás dispuesto a soltar tareas inútiles', 'Te identificas con estar ocupado, no con ser efectivo'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-700 text-base" data-id="element-193">
                  <X className="w-5 h-5 text-red-500 mt-0.5 flex-shrink-0" data-id="element-194" />
                  <span data-id="element-195">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* 12. EXPERT / ABOUT */}
      <section className="px-6 py-20 bg-slate-50" data-id="element-196">
        <div className="max-w-4xl mx-auto" data-id="element-197">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex flex-col md:flex-row items-center gap-10 md:gap-14" data-id="element-198">
            <div className="w-full max-w-xs flex-shrink-0" data-id="element-199">
              <div className="overflow-hidden rounded-2xl shadow-xl" data-id="element-200">
                <img src="https://cdn.magicpatterns.com/uploads/7QgdQEeTWR2oH82BQV7h1W/Experto.jpg" alt="Carolina Gómez - Entrenadora de Juega Desde Otro Nivel" className="w-full" data-id="element-201" />
              </div>
            </div>

            <div className="text-center md:text-left space-y-5" data-id="element-202">
              <div data-id="element-203">
                <h3 className="text-2xl font-bold text-slate-900" data-id="element-204">
                  Carolina Gómez
                </h3>
                <p className="text-orange-600 font-medium mt-1" data-id="element-205">
                  Ingeniero de formación. Estratega por experiencia. Líder por
                  resultados.
                </p>
              </div>

              <ul className="space-y-3" data-id="element-206">
                {['+20 años en ventas reales', 'Venta directa y liderazgo de equipos', 'Entrenamientos en más de 5 países'].map((item, i) => <li key={i} className="flex items-center gap-3 text-slate-700" data-id="element-207">
                    <Check className="w-5 h-5 text-orange-500 flex-shrink-0" data-id="element-208" />
                    <span className="font-medium" data-id="element-209">{item}</span>
                  </li>)}
              </ul>

              <p className="text-slate-500 italic border-l-2 border-orange-300 pl-4" data-id="element-210">
                No crecimos leyendo teoría. Crecimos ejecutando.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* 13. FAQ */}
      <FAQSection data-id="element-211" />

      {/* FOOTER */}
      <footer className="px-6 py-16 bg-slate-900 text-center border-t border-slate-800" data-id="element-212">
        <div className="max-w-4xl mx-auto space-y-8" data-id="element-213">
          <div data-id="element-214">
            <h4 className="text-2xl font-bold text-white mb-3" data-id="element-215">
              Juega Desde Otro Nivel
            </h4>
            <p className="text-slate-400 text-lg" data-id="element-216">
              Vende mejor, con menos desgaste.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-8 text-sm md:text-base" data-id="element-217">
            <button onClick={() => setShowPrivacyModal(true)} className="text-slate-300 hover:text-white transition-colors underline underline-offset-4 decoration-slate-500 hover:decoration-white" data-id="element-218">
              Política de Privacidad
            </button>
            <button onClick={() => setShowTermsModal(true)} className="text-slate-300 hover:text-white transition-colors underline underline-offset-4 decoration-slate-500 hover:decoration-white" data-id="element-219">
              Términos y Condiciones
            </button>
          </div>

          <div className="pt-6 border-t border-slate-800" data-id="element-220">
            <p className="text-slate-400 text-sm md:text-base" data-id="element-221">
              © {new Date().getFullYear()} Juega Desde Otro Nivel. Todos los
              derechos reservados.
            </p>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <AnimatePresence data-id="element-222">
        {showPrivacyModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setShowPrivacyModal(false)} className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 overflow-y-auto" data-id="element-223">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} transition={{
          type: 'spring',
          stiffness: 200,
          damping: 20
        }} onClick={e => e.stopPropagation()} className="relative max-w-3xl w-full bg-white rounded-2xl shadow-2xl max-h-[90vh] overflow-y-auto" data-id="element-224">
              <div className="sticky top-0 bg-white border-b border-slate-200 p-6 flex items-center justify-between rounded-t-2xl z-10" data-id="element-225">
                <h2 className="text-2xl font-bold text-slate-900" data-id="element-226">
                  Política de Privacidad
                </h2>
                <button onClick={() => setShowPrivacyModal(false)} className="flex items-center justify-center w-10 h-10 rounded-full bg-slate-100 hover:bg-slate-200 transition-colors" data-id="element-227">
                  <X size={20} data-id="element-228" />
                </button>
              </div>
              <div className="p-8 space-y-8 text-slate-700" data-id="element-229">
                <p data-id="element-230">Contenido de política de privacidad...</p>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Terms Modal */}
      <AnimatePresence data-id="element-231">
        {showTermsModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setShowTermsModal(false)} className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 overflow-y-auto" data-id="element-232">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} transition={{
          type: 'spring',
          stiffness: 200,
          damping: 20
        }} onClick={e => e.stopPropagation()} className="relative max-w-3xl w-full bg-white rounded-2xl shadow-2xl max-h-[90vh] overflow-y-auto" data-id="element-233">
              <div className="sticky top-0 bg-white border-b border-slate-200 p-6 flex items-center justify-between rounded-t-2xl z-10" data-id="element-234">
                <h2 className="text-2xl font-bold text-slate-900" data-id="element-235">
                  Términos y Condiciones
                </h2>
                <button onClick={() => setShowTermsModal(false)} className="flex items-center justify-center w-10 h-10 rounded-full bg-slate-100 hover:bg-slate-200 transition-colors" data-id="element-236">
                  <X size={20} data-id="element-237" />
                </button>
              </div>
              <div className="p-8 space-y-8 text-slate-700" data-id="element-238">
                <p data-id="element-239">Contenido de términos y condiciones...</p>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}